import 'angular';

import { CommunicationCenterCtrl }   from './communication-center';
import { CommunicationCenterStates } from './communication-center.states.ajs';

angular.module('workshop.communication-center', [])
  .config(CommunicationCenterStates)
  .controller('CommunicationCenterCtrl', CommunicationCenterCtrl)